import Axios from "axios";

export class User {
  // Set user url
  constructor(apiUrl, headers) {
    this.userUrl = `${apiUrl}/user`;
    this.headers = headers;
  }

  async getDecryptedIdCard(id) {
    const url = `${this.userUrl}/${id}/decrypt/id-card`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }
}
